import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'

import { EORDER_STATUS_CALL, IOrder } from '../../types/order'

interface Props {
  order: IOrder
}

const StatusCallTag = (props: Props) => {
  const { order } = props
  const isCalled = order.statusCall === EORDER_STATUS_CALL.CALLED
  const isCancelled = order.statusCall === EORDER_STATUS_CALL.CANCELLED
  return (
    <>
      {(isCalled || isCancelled) && (
        <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>
          <Tag color={isCancelled ? 'error' : 'success'}>
            {isCancelled ? 'ไม่รับสาย' : 'โทรแล้ว'}
          </Tag>
        </Box>
      )}
    </>
  )
}

export default StatusCallTag
